import {USER} from '../actions/usersActions';

const initialState = {

  user:false,
  

  };
  
  const AppReducer = (State = initialState, action) => {
    const Actions = action.type;
    switch (Actions) {
      case USER:
        return {
          user: action.payload,
        };
      default:
        return State;
    }
  };
  export default AppReducer;





  